module.exports = __webpack_public_path__ + "img/close.ccbd4ad8.svg";